import type { ReactNode } from 'react'

export function EmptyState({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-2xl border border-line bg-card px-4 py-8 text-center text-sm text-ink-soft shadow-soft">
      {children}
    </div>
  )
}
